import { API_PIVOTHEALTH } from 'core/constants/endpoints'
import { GetExternalPartnersParams, GetExternalPartnersResponse } from './types'

/**
 * Fetches external partners for a given healthcare agent.
 * It is important to ensure that the healthcare agent ID is provided in the parameters.
 * @param {GetExternalPartnersParams} params - Parameters containing the healthcare agent ID.
 * @returns {Promise<GetExternalPartnersResponse>} - A promise that resolves to an array of external partners.
 */
export default function getExternalPartners({
  healthcareAgentId
}: GetExternalPartnersParams): Promise<GetExternalPartnersResponse> {
  const url = `${API_PIVOTHEALTH}/agents/ExternalPartners/${healthcareAgentId}`

  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        console.error('[X] Failed to fetch external partners:', response.statusText)
        return []
      }
      return response.json()
    })
    .catch(error => {
      console.error('[X] Exception fetching external partners:', error)
      return []
    })
}
